import TableCard from "./TableCard";
import DataTable from "./DataTable";

export {
    TableCard,
    DataTable
};

